import { Box, Button, Grid, SpaceBetween } from "@cloudscape-design/components";
import { signOut } from "../auth/MidwayAuth";
import logo from "../assets/aws-tnc-logo.png";

export default function Header({ userId, isSignedIn }) {

  return (
    <Box>
      <Grid
        gridDefinition={[
          { colspan: { default: 3, xxs: 9 } },
          { colspan: { default: 9, xxs: 3 } },
        ]}
      >
        <SpaceBetween direction="horizontal" size="s">
          <Box margin={{ top: "s", bottom: "s" }}>
            <img src={logo} height={25} alt="AWS Training and Certification Logo" />
          </Box>
          <Box variant="h2" margin={{ top: "s", bottom: "s" }}>
            <span className="pagehead">Bedrock Item Helper</span>
          </Box>
        </SpaceBetween>
        <Box float="right" margin={{ right: "xxs", top: "xs", bottom: "xs" }} display="block">
          <SpaceBetween direction="horizontal" size="xs">
            {isSignedIn && userId && (
              <img
                src={`https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=${userId}`}
                alt="badge"
                height={24}
                style={{ borderRadius: "50%" }}
              />
            )}
            {isSignedIn && userId && (
              <Box variant="span" fontSize="body-s" color="text-status-info">{userId}@amazon.com</Box>
            )}
            {isSignedIn && (
              <Button variant="primary" onClick={() => signOut()}>
                Log out
              </Button>
            )}
          </SpaceBetween>
        </Box>
      </Grid>
    </Box>
  );
}
